module.exports = __webpack_public_path__ + "img/material.c45c9e0e.jpg";